export {
	dialogMotion,
	dialogSlideUpAndFade,
	dialogFade,
	type TDialogAnimationPreset,
} from '../dialog/animations';

export {
	popupMotion,
	slideAndFade,
	fade,
	scaleAndFade,
	type TPopoverAnimationPreset,
} from '../popover/animations';
